import { useEffect, useState } from 'react';
import { RefreshCw, X } from 'lucide-react';

import { eigeneVersion, serverVersion, versionBeobachten } from '@/app/neueVersion';
import { de } from '@/i18n/de';

const standardHolen = () => serverVersion();
const standardNeuLaden = () => window.location.reload();

/**
 * Hinweis bei neuer App-Version (F-47) - ein Streifen unter der Kopfzeile,
 * auf jeder Seite sichtbar. "Neu laden" ist eine Ein-Tipp-Aktion; "Später"
 * blendet ihn bis zur naechsten Rueckkehr in die App aus. Daten gehen beim
 * Neuladen nicht verloren - sie liegen in der Datenbank.
 */
export function UpdateHinweis({ eigene: vorgabe, holen = standardHolen, neuLaden = standardNeuLaden }: {
  /** Fuer Tests; sonst aus dem Meta-Tag der Seite. */
  eigene?: string | null;
  holen?: () => Promise<string | null>;
  neuLaden?: () => void;
}) {
  const [eigene] = useState(() => (vorgabe === undefined ? eigeneVersion() : vorgabe));
  const [neu, setNeu] = useState<string | null>(null);
  const [weg, setWeg] = useState(false);

  useEffect(() => (eigene ? versionBeobachten({ eigene, holen, beiNeu: setNeu }) : undefined), [eigene, holen]);

  useEffect(() => {
    const zurueck = () => { if (document.visibilityState === 'visible') setWeg(false); };
    document.addEventListener('visibilitychange', zurueck);
    return () => document.removeEventListener('visibilitychange', zurueck);
  }, []);

  if (!neu || weg) return null;
  return (
    <div role="status" className="flex flex-wrap items-center gap-x-3 gap-y-1 border-b border-accent/30 bg-accent/10 px-4 py-2.5 text-sm text-ink sm:px-6">
      <RefreshCw className="size-4 shrink-0 text-accent-text" aria-hidden="true" />
      <span className="min-w-0 flex-1">{de.update.hinweis}</span>
      <button type="button" onClick={neuLaden} className="shrink-0 font-medium text-accent-text underline-offset-2 hover:underline">
        {de.update.neuLaden}
      </button>
      <button type="button" aria-label={de.update.spaeter} title={de.update.spaeter} onClick={() => setWeg(true)}
        className="grid size-6 shrink-0 place-items-center rounded text-ink-faint hover:text-ink">
        <X className="size-3.5" />
      </button>
    </div>
  );
}
